<template>
    <div class="content">
        <pageTool></pageTool>
        <Header
            :page-title="title"
        ></Header>
        <div class="page-content">
            <div class="page-img">
                <a-carousel :after-change="onChange" autoplay>
                    <div v-for="(img, i) in title.list" :key="i"><img :src="title.internalInstance.appContext.config.globalProperties.$imgUrl + img"></div>
                </a-carousel>
            </div>
            <div class="page-text">
                <p>{{ title.info.title }}</p>
                <p>品种：{{ title.info.type }}</p>
                <p>价格：{{ title.info.price }} {{ title.info.company }}</p>
                <p>数量：{{ title.info.count }}</p>
                <p>日期：{{ title.info.effectiveTime }} ~ {{ title.info.failureTime }}</p>
                <p>区域：{{ title.info.address }}</p>
                <p>主体：{{ title.info.phone }}</p>
                <p>详情：</p>
                <div class="more">{{ title.info.msg }}</div>
                <div class="page-text-button">
                    <a-button type="primary" class="cus-button">
                        <a :href="'tel:' + title.info.phone">立即联系</a>
                    </a-button>
                    <a-button type="primary" class="cus-button" style="margin-left: 5px" @click="title.visible = !title.visible">意向单</a-button>
                </div>
            </div>
            <div class="page-text page-text-block" v-show="title.visible">
                <p style="margin-bottom: 20px">意向单信息</p>
                <a-form :model="TGForm" :label-col="labelCol" :wrapper-col="wrapperCol">
                    <a-form-item label="数量">
                        <a-input-number v-model:value="TGForm.count"/>
                    </a-form-item>
                    <a-form-item label="日期">
                        <a-date-picker
                            v-model:value="TGForm.deadline"
                            show-time
                            type="date"
                            placeholder="日期"
                            style="width: 100%"
                        />
                    </a-form-item>
                    <a-form-item label="姓名">
                        <a-input v-model:value="TGForm.contacts"/>
                    </a-form-item>
                    <a-form-item label="联系电话">
                        <a-input v-model:value="TGForm.phone"/>
                    </a-form-item>
                    <a-form-item label="身份证号">
                        <a-input v-model:value="TGForm.identity"/>
                    </a-form-item>
                    <a-form-item label="地址">
                        <a-input v-model:value="TGForm.address"/>
                    </a-form-item>
                </a-form>
                <div class="page-text-button">
                    <a-button type="primary" class="cus-button" @click="onsubmit">提交</a-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "@/components/SNInfo/Header"
import {onMounted, reactive, getCurrentInstance, toRaw} from "@vue/runtime-dom"
import pageTool from "@/components/nav/pageTool"
import {useRoute} from "vue-router"
import { getCommodityTypeApi, getMallDetailsApi} from '@/api/mall'
import {getPriceCompanyType} from "@/api/demand"
import {saveIntentionApi} from "@/api/intention"
import {notification} from "ant-design-vue";
const banner = require('@/assets/img/page_banner_1.png')
export default {
    name: "MallDetails",
    setup() {
        const route = useRoute()
        const title = reactive({
            cn: '',
            en: '',
            hasSearch: false,
            titleStyle: false,
            banner,
            list: [],
            id: [],
            internalInstance: getCurrentInstance(),
            info: {},
            visible: false
        })
        const TGForm = reactive({
            count: '',
            deadline: undefined,
            contacts: '',
            phone: '',
            identity: '',
            address: ''
        })
        let priceRes = reactive({})
        let orderType = reactive({})
        const getDDDomInfo = async () => {
            priceRes = await getPriceCompanyType()
            orderType = await getCommodityTypeApi()
        }
        const onChange = () => {
            // console.log(current);
        }
        const initData = async (id) => {
            await getDDDomInfo()
            const data = await getMallDetailsApi(id)
            title.info = data
            title.list = data.imgs ? data.imgs.split(',') : ''
            title.info.company = priceRes[title.info.company]
            title.info.type = orderType[title.info.type]
            document.title = title.info.title
        }
        const onsubmit = async () => {
            const value = toRaw(TGForm)
            const params = {
                count: value.count,
                deadline: value.deadline,
                contacts: value.contacts,
                phone: value.phone,
                identity: value.identity,
                address: value.address,
            }
            const data = await saveIntentionApi(params)
            if (data) {
                notification.success({ message: '提交成功！', duration: 2.5, description: '' })
                setTimeout(() => {
                    TGForm.count = ''
                    TGForm.deadline = undefined
                    TGForm.contacts = ''
                    TGForm.phone = ''
                    TGForm.identity = ''
                    TGForm.address = ''
                }, 2000)
            }
            // console.log('submit!', toRaw(formState))

        }
        onMounted(() => {
            title.cn = route.query.name
            title.id = route.query.id
            initData(title.id)
        })
        return {
            title,
            priceRes,
            orderType,
            TGForm,
            labelCol: {
                span: 6,
            },
            wrapperCol: {
                span: 16,
                offset: 2
            },
            onsubmit,
            onChange,
            initData
        }
    },
    components: {
        Header,
        pageTool
    }
}
</script>


<style scoped lang="stylus">
    .content {
        .page-content {
            padding 20px 15px
            background-color #FFF
            .page-img {
                width 100%
                overflow hidden
            }
            .page-img img {
                width 100%
            }
            .page-text-block {
                padding 15px 20px
                box-shadow 0 3px 6px rgba(0, 0, 0, 0.16)
            }
            .page-text-block >>> .ant-form-item {
                margin-bottom 0
            }
            .page-text {
                width 100%
                padding 10px 15px
                margin-top 10px
                overflow hidden
                color #575757
                font-size 14px
                .more {
                    width 100%
                    padding-left 42px
                }
                .page-text-button {
                    margin-top 15px
                    width 100%
                    text-align center
                    .cus-button {
                        width 99px
                        background #03CA8F
                        border-radius 6px
                        border-color #03CA8F
                    }
                }
            }
            .page-text p:first-child {
                font-size 15px
                font-weight bolder
                height 30px
                border-bottom 1px solid #575757
                margin-bottom 5px
            }
            .page-title {
                color #575757
                font-weight bolder
                font-size 16px
                text-align center
                width 100%
                height 30px
                overflow hidden
            }
            .page-title span {
                display inline-block
                position relative
            }
            .page-title span::before {
                display block
                content ''
                width 80px
                height 2px
                background-color #8BC53F
                position absolute
                left -90px
                top 12px
            }
            .page-title span::after {
                display block
                content ''
                width 80px
                height 2px
                background-color #8BC53F
                position absolute
                right -90px
                top 12px
            }
        }
    }
    @media (max-width: 575px) {
        .page-text-block >>> .ant-form-item-label {
            line-height 10.667vw
        }
    }
</style>